import gsap from 'gsap'
import { getLenis } from '@js/animations/Scroll'
import { reduceMotion } from '@js/animations/ReducedMotion'

const findNextSection = (section) => {
  let sibling = section.nextElementSibling

  while (sibling) {
    if (sibling.tagName === 'SECTION') {
      return sibling
    }

    sibling = sibling.nextElementSibling
  }

  return null
}

const scrollToElement = (target) => {
  const lenis = getLenis()

  if (lenis && !reduceMotion) {
    lenis.scrollTo(target)
    return
  }

  target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' })
}

export class Hero {
  constructor() {
    if (!reduceMotion) {
      document.querySelectorAll('.s-hero__discover-icon').forEach((icon) => {
        gsap.to(icon, {
          y: 8,
          duration: 0.8,
          repeat: -1,
          yoyo: true,
          ease: 'power1.inOut',
        })
      })
    }

    document.querySelectorAll('.s-hero__discover[type="button"]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const heroSection = trigger.closest('section')

        if (!heroSection) {
          return
        }

        const nextSection = findNextSection(heroSection)

        if (!nextSection) {
          return
        }

        scrollToElement(nextSection)
      })
    })
  }
}
